import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { getDriverStatusIcon } from "../../../../../../modules/Dispatch/RouteExecution/utils/DriverStatus/driverStatusIcon";

const styles = {
  container: {
    display: "flex",
    paddingBottom: 7,
    float: "right",
    wordBreak: "break-all"
  },
  driverStatusLabel: {
    paddingLeft: "5px",
    alignSelf: "center",
    textAlign: "left"
  },
  iconStyle: {
    fontSize: 18
  }
};

const DriverStatus = ({ classes, driverStatusDetails, currentStop, theme }) => {
  const { driverStatus, driverStatusLabel } = driverStatusDetails;
  const driverStatusIcon = getDriverStatusIcon({
    driverStatus,
    currentStop,
    color: theme.iconColor,
    customStyle: classes.iconStyle,
    height: 18,
    width: 18
  });
  if (!driverStatusLabel) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={`${classes.iconStyle} tableCellName`}>{driverStatusIcon}</div>
      <div className={classes.driverStatusLabel}>{driverStatusLabel}</div>
    </div>
  );
};

export default withStyles(styles)(DriverStatus);
